import { render, staticRenderFns } from "./customerLogo.vue?vue&type=template&id=4bee602c&scoped=true&"
import script from "./customerLogo.vue?vue&type=script&lang=js&"
export * from "./customerLogo.vue?vue&type=script&lang=js&"
import style0 from "./customerLogo.vue?vue&type=style&index=0&id=4bee602c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bee602c",
  null
  
)

export default component.exports